import BootstrapTable from 'react-bootstrap-table-next';
import React from 'react';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { CSVExport, Search } from 'react-bootstrap-table2-toolkit';
import {  Row, Col } from 'reactstrap';

import { FormattedMessage } from 'react-intl';
import { CustomExportCSV } from './CustomExportCSV';
const { ExportCSVButton } = CSVExport;
const { SearchBar } = Search;


export const CustomTable = ({ data, page, sizePerPage, onTableChange, totalSize, columns, shadow, selectRow, showTotal, search, remote, keyField, exportCSV, customExportCsv, handleOnClick, tooltipMessage, hideSizePerPage = true, rowStyle }) => (
    <FormattedMessage id="generic.table.nodata" defaultMessage="No Data Available">
        {placeholder =>
            <FormattedMessage id="generic.table.search" defaultMessage="Search">
                {searchPlaceholder =>
                    <ToolkitProvider
                        keyField={keyField ? keyField : 'id'}
                        data={data}
                        columns={columns}
                        search={search}
                        bootstrap4={true}
                        exportCSV={{
                            fileName: 'custom.csv'
                        }}
                    >
                        {
                            props => (

                                <div className={shadow ? 'small shadow' : 'small'}>
                                    {search || exportCSV ?
                                        <Row className="mb-2">
                                            <Col>{search ?
                                                <SearchBar className="form-control-sm" {...props.searchProps} placeholder={searchPlaceholder} />
                                                : ''}
                                            </Col>
                                            <Col>
                                                {
                                                    exportCSV ?
                                                        customExportCsv ?
                                                            <CustomExportCSV className="btn btn-host btn-sm float-right shadow" {...props.csvProps} handleOnClick={handleOnClick} tooltipMessage={tooltipMessage}>
                                                                <i className="fa-solid fa-file-excel" />
                                                            </CustomExportCSV>
                                                            :
                                                            <ExportCSVButton className="btn btn-host btn-sm float-right shadow" {...props.csvProps}>
                                                                <i className="fa-solid fa-file-excel"/>
                                                            </ExportCSVButton>
                                                        : ''
                                                }
                                            </Col>
                                        </Row>
                                        : ''}
                                    <BootstrapTable {...props.baseProps}
                                        noDataIndication={placeholder}
                                        condensed={true}
                                        bordered={false}
                                        exportCSV={exportCSV}
                                        pagination={paginationFactory({ hidePageListOnlyOnePage: true, hideSizePerPage, page, sizePerPage, showTotal: showTotal, totalSize })}
                                        onTableChange={onTableChange}
                                        remote={remote}
                                        totalSize={totalSize}
                                        hover
                                        selectRow={selectRow}
                                        rowStyle={rowStyle}


                                    />
                                </div>
                            )
                        }
                    </ToolkitProvider>
                }
            </FormattedMessage>
                }
   </FormattedMessage>
);
